import styled from 'styled-components';
import { sliderArrowStyles } from '@/styles/sliderArrows';

export const NewsSectionContainer = styled.section`
  padding: 40px 0;
  text-align: center;
`;

export const SliderWrapper = styled.div`
  width: 100% !important;
  /* min-width:0 defuses the flexbox min-width:auto trap if an ancestor is a flex
     container - lets overflow:hidden actually clip react-slick's wide track. */
  min-width: 0;
  position: relative;
  overflow: hidden;
  margin-bottom: 0;
  padding: 30px 0;

  .slick-list {
    overflow: hidden;
  }

  .slick-slide {
    padding-right: 20px;
    transition: all 0.3s ease;
  }

  .slick-dots {
    position: absolute;
    bottom: -40px;
    width: 100%;
    display: flex;
    justify-content: center;
    padding-bottom: 10px;
  }

  .slick-track {
    display: flex;
  }

  /* Shared arrow styling: white button + geometric chevron that centres
     predictably (see src/styles/sliderArrows). Replaces the old '‹'/'›' text
     glyphs, which sat off-centre. No slick theme CSS is loaded in this app. */
  ${sliderArrowStyles}

  .slick-dots li button:before {
    font-size: 10px;
    color: #c4c4c4;
  }

  .slick-dots li.slick-active button:before {
    color: #e5007d;
  }

  @media (max-width: 400px) {
    .slick-slide {
      padding: 0 10px;
    }
  }
`;

export const NewsGrid = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

export const NewsImage = styled.img`
  width: 100%;
  height: 300px;
  object-fit: cover;
  border-radius: 10px;
  transition: filter 0.3s ease;
`;

export const ImageNotAvailable = styled.div`
  width: 100%;
  height: 300px;
  object-fit: cover;
  border-radius: 10px;
  transition: filter 0.3s ease;
  background-color: #b0b0b0;
`;

// Branded no-image fallback for snapshot cards (founder direction 2026-08-24:
// the blog's yellow spirit, not the grey box). #ffd900 is the dominant accent
// colour in the blog's own theme CSS, sampled 2026-08-24.
export const SnapshotImageFallback = styled.div`
  width: 100%;
  height: 300px;
  border-radius: 10px;
  background-color: #ffd900;
`;

export const NewsCard = styled.div`
  cursor: pointer;
  width: 500px;
  background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
  margin: 20px 0;
  border: 8px solid #fff;
  transition: scale 0.3s ease;

  &:hover {
    scale: 1.02;
    ${NewsImage} {
      filter: blur(2px);
    }
  }
`;

export const NewsContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  padding: 30px;
`;

export const NewsTitle = styled.h3`
  text-align: start;
  text-transform: uppercase;
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 20px;
  height: 60px;

  @media (max-width: 800px) {
    font-size: 18px;
  }
`;

export const CategoryWrapper = styled.div`
  display: flex;
`;

export const Category = styled.span`
  color: #e5007d;
  margin: 0 10px 10px 0;
`;

export const NewsDateTime = styled.p`
  font-size: 14px;
  color: #888;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

export const NewsDescription = styled.p`
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  color: #555;
  margin-bottom: 15px;
  height: 60px;
  text-align: left;
`;

export const ReadMore = styled.a`
  font-family: 'Roboto', sans-serif;
  color: #e5007d;
  font-weight: 400;
  cursor: pointer;
  text-decoration: underline;
  &:hover {
    text-decoration: none;
    color: #e5007d;
  }

  @media (max-width: 800px) {
    margin-top: 20px;
  }
`;

export const ViewAllNewsButton = styled.a`
  padding: 12px 40px;
  font-size: 18px;
  font-weight: bold;
  color: #e5007d;
  border: 2px solid #e5007d;
  background-color: transparent;
  border-radius: 5px;
  cursor: pointer;
  transition:
    background-color 0.3s ease,
    color 0.3s ease;

  &:hover {
    background-color: #e5007d;
    color: #fff;
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  position: relative;
  background-color: white;
  padding: 40px 20px;
  border-radius: 10px;
  width: 70%;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);

  display: flex;
  align-items: center;
  gap: 10px;

  @media (max-width: 800px) {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column-reverse;
    border-radius: 0;
  }
`;

export const ModalWrapper = styled.div`
  padding: 0 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: start;
`;

export const ModalDescription = styled.p`
  font-size: 14px;
  text-align: start;
  color: #555;

  p {
    font-family: 'Roboto', sans-serif;
  }
`;
export const ModalTitle = styled.h3`
  text-transform: uppercase;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
`;

export const ModalDateTime = styled.p`
  font-size: 14px;
  color: #888;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;
export const ModalImage = styled.img`
  width: 400px;
  height: 100%;
  border-radius: 20px;
  object-fit: cover;

  @media (max-width: 800px) {
    width: 100%;
  }
`;

export const Box = styled.div`
  width: 100%;
  display: flex;
  justify-content: end;
`;
export const ViewPost = styled.a`
  cursor: pointer;
  text-transform: uppercase;
  color: #e5007d;

  display: flex;
  align-items: center;
  gap: 10px;
  transition: transform 0.3s ease;

  img {
    transform: rotate(180deg);
  }

  &:hover {
    transform: scale(1.1);
    color: #e5007d;
  }
`;

export const CloseButton = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
  transition: transform 0.3s ease;

  img {
    width: 40px;
  }

  &:hover {
    transform: rotate(180deg);
  }
`;

export const NewsCaptureBlock = styled.div`
  /* Newsletter capture replacing the old "Stories from our blog" line -
     plain centered body text, never a banner. Typography deliberately matches
     the page's standard body copy (ImpactDescription p / BackgroundIntro in
     Project.styles.ts: Roboto, 16px, weight 400, line-height 24px) so the
     sentence is indistinguishable from body text (founder, 2026-09-02);
     JoinInCapture inherits all of it. Ink is the Impact paragraph's #6d6b68. */
  margin: 0 auto;
  max-width: 560px;
  padding: 32px 16px 0;
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #6d6b68;
  text-align: center;
`;

export const NewsStateMessage = styled.p`
  margin: 0 auto 24px;
  max-width: 480px;
  padding: 32px 16px;
  font-size: 16px;
  color: #555;
`;
